import React from 'react';

import { useTranslation } from "react-i18next";


export default function ReportTabFrag(props) {
    const { data, isConfiguration, modelFctManager } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        data.childRendered = 0;
        if (isConfiguration && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!isConfiguration && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return null; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };

    var childs = [];
    if (data.templates) {
        childs = data.templates.map((child) => {
            return modelFctManager.componentTyped(child, { parentData: data, childs: data.templates, parentDisabled: data.disabled ? true : false });
        });
    }
    data.childCount = childs.length;

    var frameClass = "";
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    return <div data-name="ReportTabFrag" data-element={data.objType} className={`w-100 h-100 ${frameClass}`} style={{ overflowY: "auto", overflowX: "hidden" }}>
        {data.templates.length > 1 ? <div>{data.templates.map(template => <div>{template.title}</div>)}</div> : ""}
        {childs}
    </div>;
}